import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const PaginationControls = ({ 
    pagination, 
    onPreviousPage, 
    onNextPage, 
    onPageChange 
}) => {
    if (pagination.totalPages <= 1) return null;

    return (
        <div className="bg-white mx-2 mb-2 rounded-lg px-6 py-3 border border-gray-200 flex items-center justify-between flex-shrink-0">
            <div className="flex items-center gap-4 text-sm text-gray-600">
                <span>
                    Page {pagination.currentPage} of {pagination.totalPages}
                </span>
                <span className="text-xs text-gray-500">
                    ({pagination.totalRecords} total candidates)
                </span>
            </div>
            
            <div className="flex items-center gap-2">
                <button
                    onClick={onPreviousPage}
                    disabled={!pagination.hasPreviousPage}
                    className={`p-2 rounded-lg transition-colors ${
                        pagination.hasPreviousPage
                            ? 'text-gray-600 hover:bg-gray-100'
                            : 'text-gray-300 cursor-not-allowed'
                    }`}
                    title="Previous page"
                >
                    <ChevronLeft className="w-4 h-4" />
                </button>
                
                <div className="flex items-center gap-1">
                    {Array.from({ length: Math.min(7, pagination.totalPages) }, (_, i) => {
                        let pageNum;
                        if (pagination.totalPages <= 7) {
                            pageNum = i + 1;
                        } else {
                            const current = pagination.currentPage;
                            const total = pagination.totalPages;
                            
                            if (current <= 4) {
                                pageNum = i + 1;
                            } else if (current >= total - 3) {
                                pageNum = total - 6 + i;
                            } else {
                                pageNum = current - 3 + i;
                            }
                        }
                        
                        return (
                            <button
                                key={pageNum}
                                onClick={() => onPageChange(pageNum)}
                                className={`px-3 py-1 rounded text-sm transition-colors ${
                                    pageNum === pagination.currentPage
                                        ? 'bg-blue-500 text-white'
                                        : 'text-gray-600 hover:bg-gray-100'
                                }`}
                            >
                                {pageNum}
                            </button>
                        );
                    })}
                    
                    {pagination.totalPages > 7 && pagination.currentPage < pagination.totalPages - 3 && (
                        <>
                            <span className="text-gray-400 px-1">...</span>
                            <button
                                onClick={() => onPageChange(pagination.totalPages)}
                                className="px-3 py-1 rounded text-sm text-gray-600 hover:bg-gray-100"
                            >
                                {pagination.totalPages}
                            </button>
                        </>
                    )}
                </div>
                
                <button
                    onClick={onNextPage}
                    disabled={!pagination.hasNextPage}
                    className={`p-2 rounded-lg transition-colors ${
                        pagination.hasNextPage
                            ? 'text-gray-600 hover:bg-gray-100'
                            : 'text-gray-300 cursor-not-allowed'
                    }`}
                    title="Next page"
                >
                    <ChevronRight className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};

export default PaginationControls;